import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LinkTabs from '@/shared/components/LinkTabs';
import Header from './components/Header';
import ResetPassword from './components/ResetPassword';
import useUserAccountValues from './utils/useUserAccountValues';

const App = () => {
  const { t } = useTranslation();
  const user = useUserAccountValues();

  return (
    <div>
      <Header
        actionSlot={<ResetPassword emailAddress={user.email} />}
        subTitle={user.email}
        title={t('core.accountSettings')}
      />
      <div className="border-b">
        <LinkTabs
          items={[
            {
              key: 'settings',
              label: t('accountSettings.profile'),
              link: 'settings',
              matcher: 'settings',
            },
            {
              key: 'preferences',
              label: t('core.preferences'),
              link: 'preferences',
              matcher: 'preferences',
            },
            {
              key: 'right-to-be-forgotten',
              label: t('accountSettings.rightToBeForgotten'),
              link: 'right-to-be-forgotten',
              matcher: 'right-to-be-forgotten',
            },
          ]}
          variant="secondary"
        />
      </div>
      <div className="mt-8">
        <Outlet />
      </div>
    </div>
  );
};

export default App;
